import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      <section className="py-16 lg:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeUp}
            transition={{ duration: 0.5 }}
          >
            <h1 className="text-3xl sm:text-4xl font-bold text-zinc-950 tracking-tight mb-8">
              Impressum
            </h1>

            <div className="prose prose-zinc max-w-none">
              <h2 className="text-xl font-semibold text-zinc-900 mt-8 mb-4">
                Angaben gemäß § 5 ECG
              </h2>
              
              <div className="bg-zinc-50 rounded-xl p-6 border border-zinc-100 mb-8">
                <p className="font-semibold text-zinc-900 mb-2">Rent Mich AT</p>
                <p className="text-zinc-600">
                  Jakov Domitrek<br />
                  Haibach 29<br />
                  4204 Haibach im Mühlkreis<br />
                  Österreich
                </p>
              </div>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Kontakt</h3>
              <p className="text-zinc-600 mb-4">
                Telefon: +43 676 4138585<br />
                E-Mail: info@rentmich.at
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Gewerbeberechtigung</h3>
              <p className="text-zinc-600 mb-4">
                <strong>GISA-Zahl:</strong> 37878085<br />
                <strong>Aufsichtsbehörde:</strong> Bezirkshauptmannschaft Urfahr-Umgebung<br />
                <strong>Mitglied bei:</strong> WKO (Wirtschaftskammer Österreich)
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Berechtigungen</h3>
              <ul className="list-disc list-inside text-zinc-600 mb-4">
                <li>LG Versand-, Internet- und allgemeiner Handel</li>
                <li>Handelsgewerbe mit Ausnahme der reglementierten Handelsgewerbe und Handelsagent</li>
              </ul>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">EU-Streitschlichtung</h3>
              <p className="text-zinc-600 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:underline ml-1">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="text-zinc-600 mb-4">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h3>
              <p className="text-zinc-600 mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Haftung für Inhalte</h3>
              <p className="text-zinc-600 mb-4">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                Tätigkeit hinweisen.
              </p>
              <p className="text-zinc-600 mb-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Haftung für Links</h3>
              <p className="text-zinc-600 mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf 
                mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der 
                Verlinkung nicht erkennbar.
              </p>

              <h3 className="text-lg font-semibold text-zinc-900 mt-6 mb-3">Urheberrecht</h3>
              <p className="text-zinc-600">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und 
                jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der 
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
